import {
  MessageSquareReply,
  PhoneMissed,
  FileText,
  CalendarCheck,
  History,
  BellRing,
  ListChecks,
  BarChart3,
} from "lucide-react";
import { Reveal, Chapter } from "../components/Reveal";

const SERVICES = [
  {
    icon: MessageSquareReply,
    title: "New enquiry response",
    text: "Every new enquiry receives a fast, structured first response, whatever time it arrives.",
  },
  {
    icon: PhoneMissed,
    title: "Missed enquiry follow-up",
    text: "Enquiries that slip through during busy periods are picked up and responded to.",
  },
  {
    icon: FileText,
    title: "Treatment enquiry follow-up",
    text: "People who ask about specific treatments are followed up in a consistent, timely way.",
  },
  {
    icon: CalendarCheck,
    title: "Consultation booking",
    text: "Interested patients are guided towards booking a consultation at a time that suits them.",
  },
  {
    icon: History,
    title: "Lead reactivation",
    text: "Older enquiries that never booked are re-engaged with a structured approach.",
  },
  {
    icon: BellRing,
    title: "Appointment reminders",
    text: "Reminders help reduce missed consultations and last-minute gaps in the diary.",
  },
  {
    icon: ListChecks,
    title: "Enquiry tracking",
    text: "Every enquiry is tracked from first contact through to booking, so nothing quietly disappears.",
  },
  {
    icon: BarChart3,
    title: "Reporting",
    text: "Clear reporting shows enquiry volume, response times and bookings in one place.",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="scroll-mt-24 border-t border-ink/10 py-24 md:py-32"
    >
      <div className="mx-auto max-w-6xl px-6">
        <Reveal>
          <Chapter number="05" label="Services" />
        </Reveal>
        <Reveal delay={60}>
          <h2 className="font-display text-3xl font-medium leading-tight tracking-tight text-ink sm:text-4xl lg:text-5xl">
            What&apos;s included
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={(i % 4) * 100} className="h-full">
              <div
                data-testid={`service-card-${i}`}
                className="h-full rounded-2xl border border-ink/10 bg-white p-7 transition-colors hover:border-teal/40"
              >
                <div className="flex h-11 w-11 items-center justify-center rounded-full bg-teal-soft">
                  <s.icon size={20} className="text-teal" strokeWidth={1.8} />
                </div>
                <h3 className="mt-5 font-medium tracking-wide text-ink">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-ink/65">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
